import type { UppFloorPlanStageComponent } from '../canvas/upp-floor-plan-stage.component';

/**
 * Imperative multi-selection helpers bound to the current Konva stage. Methods no-op when the inner selection rules do not apply
 * (same guards as {@link UppFloorPlanStageComponent.alignSelectedElements} / {@link UppFloorPlanStageComponent.distributeSelectedElements}).
 */
export class UppFloorPlanDrawGroup {
  constructor(private readonly _floor: UppFloorPlanStageComponent) {}

  /** `vertical` = align screen-X centers; `horizontal` = align screen-Y centers (see floor plan component). */
  alignCenters(axis: 'vertical' | 'horizontal'): void {
    this._floor.alignSelectedElements(axis);
  }

  /** Even gaps along screen axes between projected bboxes. */
  distributeEven(axis: 'vertical' | 'horizontal'): void {
    this._floor.distributeSelectedElements(axis);
  }

  /**
   * Same width, height, and rotation for every transformable selected element of uniform {@link UppKonvaElementKind}.
   * @returns `true` when the floor applied the change.
   */
  applyUniformGeometry(widthCm: number, heightCm: number, rotationDeg: number): boolean {
    return this._floor.applyUniformGeometryToSelection(widthCm, heightCm, rotationDeg);
  }

  canGroupResize(): boolean {
    return this._floor.canGroupResizeSelection();
  }

  selectionIsUniformKind(): boolean {
    return this._floor.selectionIsUniformKind();
  }
}
